const config = {
  nporadio1: {
    name: 'NPO Radio 1',
    playerId: 'npo-radio-1',
    websiteUrl: 'https://www.nporadio1.nl/',
    init() {
      this.tracksApiUrl = `${this.websiteUrl}api/tracks`;
      this.broadcastsApiUrl = `${this.websiteUrl}api/broadcasts`;
      this.playlistUrl = `${this.websiteUrl}gemist`;
      this.liveUrl = `${this.websiteUrl}live`;
      return this;
    }
  }.init(),
  nporadio2: {
    name: 'NPO Radio 2',
    playerId: 'npo-radio-2',
    websiteUrl: 'https://www.nporadio2.nl/',
    init() {
      this.subChannelsUrl = `${this.websiteUrl}soulenjazz`;
      this.tracksApiUrl = `${this.websiteUrl}api/tracks`;
      this.broadcastsApiUrl = `${this.websiteUrl}api/broadcasts`;
      this.playlistUrl = `${this.websiteUrl}playlist`;
      this.liveUrl = `${this.websiteUrl}live`;
      return this;
    }
  }.init(),
  npo3fm: {
    name: 'NPO 3FM',
    playerId: 'npo-3fm',
    websiteUrl: 'https://www.npo3fm.nl/',
    init() {
      this.subChannelsUrl = `${this.websiteUrl}programmas/frequenties`;
      this.tracksApiUrl = `${this.websiteUrl}api/tracks`;
      this.broadcastsApiUrl = `${this.websiteUrl}api/broadcasts`;
      this.playlistUrl = `${this.websiteUrl}muziek/gedraaid`;
      this.liveUrl = `${this.websiteUrl}live`;
      return this;
    }
  }.init(),
  nporadio4: {
    name: 'NPO Klassiek',
    playerId: 'npo-radio-4',
    websiteUrl: 'https://www.npoklassiek.nl/',
    init() {
      this.tracksApiUrl = `${this.websiteUrl}api/tracks`;
      this.broadcastsApiUrl = `${this.websiteUrl}api/broadcasts`;
      this.playlistUrl = `${this.websiteUrl}gedraaid`;
      this.liveUrl = `${this.websiteUrl}live`;
      return this;
    }
  }.init(),
  nporadio5: {
    name: 'NPO Radio 5',
    playerId: 'npo-radio-5',
    websiteUrl: 'https://www.nporadio5.nl/',
    init() {
      this.subChannelsUrl = `${this.websiteUrl}sterrennl`;
      this.tracksApiUrl = `${this.websiteUrl}api/tracks`;
      this.broadcastsApiUrl = `${this.websiteUrl}api/broadcasts`;
      this.playlistUrl = `${this.websiteUrl}gedraaid`;
      return this;
    }
  }.init(),
  nposterrennl: {
    name: 'NPO Radio 5',
    playerId: 'npo-sterren-nl',
    websiteUrl: 'https://www.nporadio5.nl/sterrennl',
    tracksApiUrl: 'https://www.nporadio5.nl/api/sterrennl/tracks',
    broadcastsApiUrl: 'https://www.nporadio5.nl/api/sterrennl/broadcasts',
    playlistUrl: 'https://www.nporadio5.nl/sterrennl/playlist'
  },
  npofunx: {
    name: 'NPO Funx',
    playerId: 'npo-funx',
    websiteUrl: 'https://www.funx.nl/',
    init() {
      this.subChannelsUrl = `${this.websiteUrl}radio/frequenties`;
      this.tracksApiUrl = `${this.websiteUrl}api/tracks`;
      this.broadcastsApiUrl = `${this.websiteUrl}api/broadcasts`;
      this.playlistUrl = `${this.websiteUrl}radio/playlist/npo-funx`;
      this.liveUrl = `${this.websiteUrl}radio/kijk-live`;
      return this;
    }
  }.init(),
  npoblend: {
    name: 'NPO Blend',
    playerId: 'npo-blend',
    websiteUrl: 'https://www.npoblend.nl/',
    tracksApiUrl: 'https://api.nporadio.nl/api/tracks/npo-blend.json',
    broadcastsApiUrl: 'https://api.nporadio.nl/api/broadcasts/npo-blend.json',
    playlistUrl: 'https://www.npoblend.nl/gedraaid'
  }
};

module.exports = config;
